module.exports = __webpack_public_path__ + "img/admin_audit.13694ca3.svg";